import { Datagrid, List, TextField } from "react-admin";

const PartyTypeList = (props) => {
    return (
        <List
            exporter={false}
            bulkActionButtons={false}
            sort={{ field: 'name', order: "ASC" }}
            title={'Sujeitos processuais'}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} />
            </Datagrid>
        </List>
    )
}


export default PartyTypeList;